import {PREFIX_WIND_DIR} from './behaviour_models_utils';

export function calculateDIR(wd) {
  const wind_dir = wd[PREFIX_WIND_DIR];
  if (typeof wind_dir !== 'undefined') {
    if (wind_dir < 180) {
      return wind_dir + 180;
    }
    return wind_dir - 180;
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/shared/direction.js